import React, { ReactElement } from 'react';
import ContactForm from '../Misc/Contact/ContactForm';

import s from './Portfolio.module.scss';
import { Customer } from '../../shared/schema/CustomerSchema';
import { Project } from '../../shared/schema/ProjectSchema';

interface InquiryProps {
  customer: Customer;
  project: Project;
  defaultText: string | null;
}

export default function Inquiry(props: InquiryProps): ReactElement {
  const { customer, project, defaultText } = props;

  return (
    <>
      <div className={s.subTitle}>Anfrage an {customer.businessName}</div>
      <div style={{ marginTop: '2rem', width: '100%' }}>
        <ContactForm
          customerId={customer.id}
          projectId={project.id}
          defaultText={defaultText}
        />
      </div>
    </>
  );
}
